import { distinctUntilChanged, type MonoTypeOperatorFunction } from 'rxjs';
import { deepEqual } from 'fast-equals';

export const deepDistinctUntilChanged = <T>(): MonoTypeOperatorFunction<T> =>
  distinctUntilChanged<T>((a, b): boolean => deepEqual(a, b));
